<app-modal [title]="'Blueprint Progress'" [size]="'lg'" (close)="close()">
  <div class="space-y-4">
    <div class="grid grid-cols-2 gap-4 text-sm">
      <div><strong>Status:</strong> {{ RequestStatusRenderer(data.status) }}</div>
      <div><strong>Blueprint Completed:</strong>
        <span *ngIf="data.blueprintCompleted" class="text-green-600 inline-flex items-center text-font-bold"> Yes</span>
        <span *ngIf="!data.blueprintCompleted" class="text-red-600 inline-flex items-center text-font-bold"> No</span>
      </div>
      <div><strong>Created At:</strong> {{ data.createdAt | date:'short' }}</div>
      <!-- <div><strong>Completed At:</strong> {{ data.completedAt ? (data.completedAt | date:'short') : '—' }}</div> -->
    </div>
    <hr class="my-2">
    <h3 class="text-base font-semibold mb-2">Task Progress</h3>
    <div class="overflow-x-auto">
      <table class="min-w-full text-sm border rounded-lg">
        <thead class="bg-gray-100">
          <tr>
            <th class="px-3 py-2 text-left">Assigned To</th>
            <th class="px-3 py-2 text-left " colspan="1"></th>
            <!-- <th class="px-3 py-2 text-left">Task Completed</th> -->
            <th class="px-3 py-2 text-left">Completed At</th>
            <th class="px-3 py-2 text-left">Has Completed</th>
            <th class="px-3 py-2 text-left">Comment</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let t of data.tasks" class="border-t">
            <td class="px-3 py-2">
              <ng-container *ngIf="hasAssignedAssignees(t)">
                <ng-container *ngFor="let a of getAssignedAssignees(t)">
                  <div class="mb-1">
                    <span>{{ a.name }}</span>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!hasAssignedAssignees(t)">—</ng-container>
            </td>
            <td class="px-3 py-2" colspan="1">
              <!-- {{ t.role }}<span *ngIf="t.roleInfo?.name"> ({{ t.roleInfo?.name }})</span> -->
            </td>
            <!-- <td class="px-3 py-2">
              <span [ngClass]="{'text-green-600 font-semibold': t.taskCompleted, 'text-gray-500': !t.taskCompleted}">
                {{ t.taskCompleted ? 'Yes' : 'No' }}
              </span>
            </td> -->
            <td class="px-3 py-2">
              {{ t.completedAt ? (t.completedAt | date:'h:mm a') : '—' }}
            </td>
            <td class="px-3 py-2">
              <ng-container *ngIf="hasAssignedAssignees(t)">
                <ng-container *ngFor="let a of getAssignedAssignees(t)">
                  <div class="mb-1">
                    {{ t.taskCompleted ? 'Yes' : 'No' }}
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!hasAssignedAssignees(t)">—</ng-container>
            </td>
            <td class="px-3 py-2">
              <button
                *ngIf="t.commentMsg && t.commentMsg.length > 0"
                type="button"
                class="hover:text-blue-600"
                (mouseenter)="!isMobile() && showCommentsTooltip($event, t.commentMsg)"
                (mouseleave)="!isMobile() && scheduleHideTooltip()"
                (click)="isMobile() && showCommentsTooltip($event, t.commentMsg)"
                title="View Comments"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-1.274 4.057-5.065 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </button>
              <span *ngIf="!t.commentMsg || t.commentMsg.length === 0" class="text-gray-400">—</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-comments-tooltip
      *ngIf="tooltipVisible"
      [comments]="tooltipComments"
      [isVisible]="tooltipVisible"
      [position]="tooltipPosition"
      (mouseLeave)="scheduleHideTooltip()"
      (mouseEnter)="cancelHideTooltip()"
    ></app-comments-tooltip>
  </div>
</app-modal>